/**
 * A simple js switch button that toggles the visibility of tagged admin functions
 */
define('admin',['controller'], function(controller) {
	var elementsShown = false;

	function updateVisibility() {
		$('.hidden-admin-element').toggle(elementsShown);

		if (elementsShown) {
			// let's count how many hidden admin elements are visible now;
			// as there might be duplicated elements for responsive reasons this
			// is not always equal to the number of items we hit with the toggle
			var numberOfAffectedItems = $('.hidden-admin-element:visible').length;
			$('.admin-toggler').text('Adminfunktionen ('+numberOfAffectedItems+')');
		} else {
			$('.admin-toggler').text('Adminfunktionen');
		}
	}

	$('.admin-toggler').click(function(e) {
		elementsShown = !elementsShown;
		updateVisibility();
	});

	controller.on(function() {
		updateVisibility();
	});
});

